import clsx from 'clsx';
import React from 'react';
import { useRemarkSync } from 'react-remark';
import { motion, MotionProps } from 'framer-motion';
import { AssessmentEditableField } from '../AssessmentEditableField';
import { useAssessmentEditableField, UseAssessmentEditableFieldArgs } from '../../hooks/useAssessmentEditableField';

export interface ObservationTileProps {
  className?: string;
  observation: string;
  footer?: React.ReactNode;
  motionProps?: MotionProps;
  assessmentEditableFieldArgs?: Pick<UseAssessmentEditableFieldArgs, 'onExitEditMode' | 'placeholder'>;
}

export const ObservationTile: React.FC<ObservationTileProps> = ({
  observation,
  className,
  footer,
  motionProps,
  assessmentEditableFieldArgs,
}) => {
  const reactObservation = useRemarkSync(observation);
  const assessmentEditableField = useAssessmentEditableField({
    controlledContent: observation,
    ...assessmentEditableFieldArgs,
  });

  return (
    <div className="h-full flex flex-col">
      <motion.div
        className={clsx(
          'p-6 prose prose-neutral max-w-none dark:prose-invert shadow-classic rounded-t-2xl bg-darkMode-neutral/40',
          'prose-p:!text-base prose-p:last-of-type:!mb-0 prose-p:first-of-type:!mt-0',
          'prose-headings:first-of-type:mt-0 prose-headings:text-palette-600',
          'flex-1',
          className
        )}
        {...motionProps}
      >
        <AssessmentEditableField
          textAreaClassName="!text-base"
          readOnlyContent={reactObservation}
          useAssessmentEditableFieldReturn={assessmentEditableField}
        />
      </motion.div>
      {footer}
    </div>
  );
};

export default ObservationTile;
